export default __webpack_public_path__ + "static/media/img-1-1000x900.d0ffb9f8.jpg";